// extracted by mini-css-extract-plugin
export default {"wrapper":"notecard-editor-panel__wrapper____zWma","container":"notecard-editor-panel__container___rOZUD"};